export const USER_STATUS_INACTIVE = 0;
export const USER_STATUS_ACTIVE = 1;

function getUserStatusDescription(status, translations) {
	switch (status) {
		case USER_STATUS_ACTIVE:
			return translations.statusActive;
		case USER_STATUS_INACTIVE:
			return translations.statusInactive;
		default:
			return translations.statusUnknown;
	}
}

export default getUserStatusDescription;
